import { Outlet, createFileRoute } from '@tanstack/react-router';
import { requireInternalOrganisation } from '@/lib/staffGate.ts';

/* Journey types are set up by Wundo's own people, behind the same inner door as `/admin`. */
export const Route = createFileRoute('/_app/journey-types')({
  beforeLoad: ({ context }) => requireInternalOrganisation(context.queryClient),
  component: Outlet,
});
